// animation speeds
export const speed = {
  default: 150
};

export default {
  shrinkOut: {
    animation: {
      height: 0
    },
    style: {
      overflowY: 'hidden',
      overflowX: 'visible'
    },
    duration: 150,
    easing: 'ease-out'
  },
  blinkIn: {
    animation: {
      opacity: 1,
      rotateX: '0deg'
    },
    style: {
      opacity: 0,
      rotateX: '90deg'
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  blinkOut: {
    animation: {
      opacity: 0,
      rotateX: '90deg'
    },
    style: {
      opacity: 1,
      rotateX: '0deg'
    },
    duration: speed.default,
    easing: 'ease-in'
  },
  slideUpIn: {
    animation: {
      translateY: 0
    },
    style: {
      zIndex: 11
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  slideUpOut: {
    animation: {
      translateY: '100%'
    },
    style: {
      zIndex: 11
    },
    duration: speed.default,
    easing: 'ease-in'
  },
  slideDownIn: {
    animation: {
      translateY: 0
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  slideDownOut: {
    animation: {
      translateY: '-100%'
    },
    duration: speed.default,
    easing: 'ease-in'
  },
  slideLeftIn: {
    animation: {
      translateX: 0,
      zIndex: 11
    },
    style: {
      translateX: '100%',
      zIndex: 11
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  slideLeftOut: {
    animation: {
      translateX: '100%',
      zIndex: 0
    },
    style: {
      translateX: 0,
      backgroundColor: 'white',
      zIndex: 0
    },
    duration: speed.default,
    easing: 'ease-in'
  },
  slideRightIn: {
    animation: {
      translateX: 0
    },
    style: {
      zIndex: 10,
      translateX: '-100%'
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  slideRightOut: {
    animation: {
      translateX: '-100%'
    },
    style: {
      translateX: 0
    },
    duration: speed.default,
    easing: 'ease-in'
  },
  noOp: {
    animation: {
      zIndex: 5
    },
    style: {
      zIndex: 5
    },
    duration: speed.default
  },
  fadeIn: {
    animation: {
      opacity: 1
    },
    style: {
      opacity: 0
    },
    duration: speed.default,
    easing: 'ease-out'
  },
  fadeOut: {
    animation: {
      opacity: 0
    },
    style: {
      opacity: 1
    },
    duration: speed.default,
    easing: 'ease-in'
  }
};

export function createAnimation(
  startStyle = {},
  endStyle = {},
  duration = 100,
  easing = 'ease'
) {
  return {
    animation: endStyle,
    style: startStyle,
    duration,
    easing
  };
}
